import * as React from "react";
import { SVGProps } from "react";
const SvgLogoAnthropic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-anthropic_svg__a)">
      <path
        d="M11.64 2H9.195l4.46 11.28H16.1L11.64 2ZM4.56 2 .1 13.28h2.5l.919-2.36h4.668l.903 2.36h2.498L7.128 2H4.56Zm-.243 6.82 1.527-3.957L7.371 8.82H4.317Z"
        fill="#4D4D4D"
      />
    </g>
    <defs>
      <clipPath id="logo-anthropic_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoAnthropic;
